import React from "react";
import "./App.scss";
import Main from "./containers/Main";
//sds
function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
